<template>
  <v-dialog :value="show" max-width="500" @input="(val) => outsideClick(val)">
    <v-card>
      <CloseDialogButton :close="closeAuth" />
      <ResetPasswordRequest :closeAuth="closeAuth" />
    </v-card>
  </v-dialog>
</template>

<script>
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";
import ResetPasswordRequest from "@/components/Auth/ResetPasswordRequest/Request.vue";

export default {
  name: "ResetPasswordRequestDialog",
  components: { CloseDialogButton, ResetPasswordRequest },
  props: {
    closeAuth: Function,
    outsideClick: Function,
    show: Boolean,
  },
};
</script>
